import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import {
    NgForm,
    FormGroup,
    FormControl,
    FormArray,
    Validators,
    ValidatorFn,
    AsyncValidatorFn
} from '@angular/forms';
import { FormInlineRowComponent } from './../forms/form-inline-row';
import { MessageComponent, BaseComponent } from '../common/common-components';
import { BankAccountService } from "./bank-account-service";
import { ModalService } from "../services/modal-service";
import { MessageService } from "../services/message-service";
import { DictionaryService } from '../services/dictionary-service';
import { UserService } from '../user/user-service';
declare var ga: any;

@Component({
    selector: 'dk-bank-account-owner-edit',
    inputs: ['id'],
    template: require('./bank-account-owner-edit.html'),
    entryComponents: [],
    providers: [DictionaryService]
})

export class BankAccountOwnerEditComponent extends BaseComponent implements OnInit {
    public id: number;
    @Output() cancel = new EventEmitter();
    smsMode: boolean;
    public countries: any[];
    ThirdParty: any[];
    showThirdPartyTransferAccept: boolean = false;

    form: FormGroup = new FormGroup({
        ThirdPerson: new FormControl(null, Validators.required),
        ShortName: new FormControl('', Validators.required),
        Name: new FormControl('', Validators.required),
        Address: new FormControl('', Validators.required),
        City: new FormControl('', Validators.required),
        ZipCode: new FormControl('', Validators.required),
        CountryID: new FormControl('', Validators.required),
        ThirdPartyTransferAccepted: new FormControl(false),
        SmsCode: new FormControl('')
    });

    constructor(private bankAccountService: BankAccountService,
        private modalService: ModalService,
        private messageService: MessageService,
        private dictionaryService: DictionaryService) {
        super();
    }

    ngOnInit() {
        this.ThirdParty = [
            { "Id": "0" , "Name": "Jestem właścicielem" },
            { "Id": "1" , "Name": "Osoba trzecia" }
        ];
        this.load();
        this.form.controls['CountryID'].setValue(167);
        this.dictionaryService.countries().subscribe(countries => {
            this.countries = countries;
        });

        this.form.controls['ThirdPerson'].valueChanges.subscribe(value => {
            this.showThirdPartyTransferAccept = value == 1;

            if(this.id) return;

            if(value==0){
                this.bankAccountService.owner(null).subscribe(data => {
                    this.initFormGroup(this.form, data);
                })
            } else if(value==1){                
                this.form.patchValue({
                    ShortName: '',
                    Name: '',
                    Address: '',
                    City: '',
                    ZipCode: ''
                });
            }
        });
    }

    submit() {
        if (this.smsMode == true) {
            return;
        }
        this.touchFormGroup(this.form);
        if (this.form.valid) {
            var owner = this.form.value;
            owner.OwnerID = this.id;
            this.bankAccountService.isAccountBankCodeChangeLocked().subscribe(isLocked => {
                if (isLocked) {
                    this.smsMode = true;
                    this.modalService.sendSmsCode();
                    this.form.controls['SmsCode'].setValue('');
                    return;
                }
                this.bankAccountService.editOwner(owner).subscribe(() => {
                    this.load();
                    this.messageService.success('BankAccountRecipients.DataSavedSuccessfully');
                    this.cancel.emit();
                    ga('send', 'event', 'konta', 'edycja-wlasciciela', null, null, owner);
                }, (error) => {
                    this.messageService.errorByMessageId(error.messageId);
                });
            });
        }
    }

    back() {
        this.smsMode = false;
    }

    confirmWithSms() {
        this.touchFormGroup(this.form);
        
        if (this.form.valid) {
            var owner = this.form.value;
            owner.OwnerID = this.id;
            let code = this.form.controls['SmsCode'].value;
            this.bankAccountService.editOwner(owner, code).subscribe(() => {
                this.load();
                this.messageService.success('BankAccountRecipients.DataSavedSuccessfully');
                this.cancel.emit();
                ga('send', 'event', 'konta', 'edycja-wlasciciela', null, null, owner);
                this.smsMode = false;
                this.form.controls['SmsCode'].setValue('');
            }, (error) => {
                this.messageService.errorByMessageId(error.messageId);
                this.smsMode = false;
                this.form.controls['SmsCode'].setValue('');
            });
        }
    }

    public load() {
        if (this.id) {
            this.bankAccountService.owner(this.id).subscribe(data => {

                if (data['ThirdPerson']!=null) {
                    data['ThirdPerson'] = data['ThirdPerson'].toString();
                }

                this.initFormGroup(this.form, data);
                // this.form.controls['ThirdPerson'].value = (data['ThirdPerson'] == null ? null : (data['ThirdPerson'] ? 1 : 0));
                // console.log(this.form.controls['ThirdPerson'])
            })
        }
    }

    public cancelEdit() {
        this.cancel.emit();
    }
}
